import { GlobalModule } from '@techmore/global';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TranslateModule } from '@ngx-translate/core';
import { TechmoreSharedModule } from '@techmore/share';
import { ShareSocialModalComponent } from './component/share-social-modal/share-social-modal.component';
import { GoogleClassroomModule } from '../google-classroom/google-classroom.module';


/** 素材detail頁面模組 */
@NgModule({
  declarations: [
    ShareSocialModalComponent
  ],
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    TechmoreSharedModule,
    GlobalModule,
    GoogleClassroomModule,
  ],
  exports: [
    ShareSocialModalComponent
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA,
  ]
})
export class ShareDetailModule { }
